import Vue, { CreateElement } from '@src/vue'

import { Component } from 'vue-property-decorator'

import './mobile-only.sass'

@Component
export class MobileOnly extends Vue {

  render (h: CreateElement) {
    return (
      <div class='mobile-only'>
        {this.$slots.default}
      </div>
    )
  }

}
